/* tslint:disable */
/* eslint-disable */
export enum WorkItemCalculatedbyOperatorEnum {
  Addition = 'Addition',
  Subtraction = 'Subtraction',
  Multiplication = 'Multiplication',
  Division = 'Division'
}
